import { setPhotosErrors } from '../../product/errors';
import { getAltTextError } from '../../validations/photos';
import { moveListItem } from '../../iterable/moveListItem';

import { MAX_NUMBER_OF_PHOTOS } from '../../../constants/validations';
import { OPERATIONS } from '../../../constants/bulkEdit';
import { EMPTY } from '../../../constants';
import { VALUE } from '../../../constants/product';
import { FORM } from '../../../constants/forms';

export default function photos({ actions: actionsToDispatch, operation, product }) {
  const channel = product.get('channel');

  function deletePhotos(result, photo, index) {
    return operation.getIn([VALUE, index])
      ? result
      : result.push(photo);
  }

  function replacePhotos(photo, index) {
    return operation.getIn([VALUE, index]) || photo;
  }

  function validateAndApply(value) {
    return {
      actions: actionsToDispatch,
      product: setPhotosErrors({ product: product.setIn([FORM.PHOTOS, VALUE], value) }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].PHOTOS.ADD: {
      const value = product
        .getIn([FORM.PHOTOS, VALUE])
        .concat(operation.get(VALUE))
        .slice(0, MAX_NUMBER_OF_PHOTOS[channel]);

      return validateAndApply(value);
    }

    case OPERATIONS[channel].PHOTOS.CHANGE_TO: {
      return validateAndApply(operation.get(VALUE));
    }

    case OPERATIONS[channel].PHOTOS.DELETE: {
      return validateAndApply(product.getIn([FORM.PHOTOS, VALUE]).reduce(deletePhotos, EMPTY.LIST));
    }

    case OPERATIONS[channel].PHOTOS.REPLACE: {
      return validateAndApply(product.getIn([FORM.PHOTOS, VALUE]).map(replacePhotos));
    }

    case OPERATIONS[channel].PHOTOS.SWAP: {
      const value = moveListItem(
        product.getIn([FORM.PHOTOS, VALUE]),
        operation.getIn([VALUE, 'sourceIdx']),
        operation.getIn([VALUE, 'targetIdx'])
      );

      return { actions: actionsToDispatch, product: product.setIn([FORM.PHOTOS, VALUE], value) };
    }

    case OPERATIONS[channel].PHOTOS.UPDATE: {
      const index = operation.getIn([VALUE, 'index']);

      if (!product.getIn([FORM.PHOTOS, VALUE, index])) {
        return { actions: actionsToDispatch, product };
      }

      return operation
        .getIn([VALUE, 'attributes'])
        .reduce(
          function reduceAttributes(result, value, key) {
            switch (key) {
              case 'alt_text': {
                if (!getAltTextError({ channel, value })) {
                  result.product = result.product.setIn([FORM.PHOTOS, VALUE, index, key], value);
                }

                break;
              }

              default: {
                result.product = result.product.setIn([FORM.PHOTOS, VALUE, index, key], value);
                break;
              }
            }

            return result;
          },
          { actions: actionsToDispatch, product },
        );
    }

    default: {
      break;
    }
  }

  return { actions: actionsToDispatch, product };
}
